import { lazy } from "react";
import { Navigate } from "react-router";
import AuthGuard, { UserGuard } from "src/guards/AuthGuard";
import UserLayout from "src/layouts/user";
import Loadable from "../Loadable";
import businessBuilder from "./businessBuilder";
import financial from "./financial";
import genealogy from "./genealogy";
import helpCenter from "./helpCenter";
import profile from "./profile";
import subscriptions from "./subscriptions";

const ProductList = Loadable(
  lazy(() =>
    import(
      "src/pages/userSide/onlineStore/productSubscription/productList/index"
    )
  )
);
const ProductDetails = Loadable(
  lazy(() =>
    import("src/pages/userSide/onlineStore/productSubscription/details/index")
  )
);
const Checkout = Loadable(
  lazy(() =>
    import("src/pages/userSide/onlineStore/productSubscription/checkout/index")
  )
);
const MyOrders = Loadable(
  lazy(() => import("src/pages/userSide/onlineStore/myOrders/index"))
);

const InvoiceDetails = Loadable(
  lazy(() => import("src/pages/dashboard/InvoiceDetails"))
);

const BlogPosts = Loadable(
  lazy(() => import("src/pages/userSide/blogs/BlogPosts"))
);
const BlogPost = Loadable(
  lazy(() => import("src/pages/userSide/blogs/BlogPost"))
);

const Dashboard = Loadable(
  lazy(() => import(`src/pages/userSide/dashboard/index`))
);

const IncomeReport = Loadable(
  lazy(() => import("src/pages/userSide/incomeReport"))
);
const MissedPoints = Loadable(
  lazy(() => import("src/pages/userSide/missedPoints"))
);
const InvoiceUser = Loadable(
  lazy(() => import("src/pages/userSide/invoice/index"))
);

const Events = Loadable(lazy(() => import("src/pages/userSide/events/index")));
const Points = Loadable(lazy(() => import("src/pages/userSide/points/index")));
const InvoiceHistory = Loadable(
  lazy(() => import("src/pages/userSide/invoiceHistory/index"))
);
const user = [
  {
    path: "user",
    element: (
      <AuthGuard>
        <UserGuard>
          <UserLayout />
        </UserGuard>
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="dashboard" />, index: true },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "events",
        element: <Events />,
      },
      {
        path: "online-store",
        children: [
          {
            path: "product-subscription",
            children: [
              { index: true, element: <ProductList /> },
              {
                path: "checkout",
                element: <Checkout />,
              },
              { path: ":name", element: <ProductDetails /> },
            ],
          },
          {
            path: "my-orders",
            children: [
              { index: true, element: <MyOrders /> },
              {
                path: ":id",
                element: <InvoiceDetails />,
              },
            ],
          },
        ],
      },
      {
        path: "events",
        element: <Events />,
      },
      {
        path: "blogs",
        children: [
          { index: true, element: <BlogPosts /> },
          { path: ":id", element: <BlogPost /> },
        ],
      },

      { path: "income-report", element: <IncomeReport /> },
      { path: "missed-points", element: <MissedPoints /> },
      { path: "invoice-user", element: <InvoiceUser /> },

      {
        path: "invoice-history",
        children: [
          { index: true, element: <Navigate to="1" /> },
          { path: ":id", element: <InvoiceHistory /> },
        ],
      },

      { path: "points", element: <Points /> },
      { ...businessBuilder },
      { ...genealogy },
      { ...subscriptions },
      { ...financial },
      { ...helpCenter },
      { ...profile },
    ],
  },
];

export default user;
